"use strict";
/* eslint-disable @typescript-eslint/indent */
/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable no-multiple-empty-lines */
/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable no-multi-spaces */
/* ______________________________________________________________________________
  Physics models  Data types used for modeling the trainer, ball launch/flight
  All geometric quantities are in 'physics coordinates' unless
  otherwise noted.
  See Also: Coordinate Systems and Units (in conversions.ts)
  ______________________________________________________________________________
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultSimulationParams = exports.DefaultPhysicalConstants = exports.CourtGeometryBySport = exports.BallParamsBySport = exports.CourtSurface = exports.ValidPhysicsModelNames = exports.Sports = exports.metersPerYard = exports.metersPerInch = exports.metersPerFoot = void 0;
exports.isSport = isSport;
// Length conversions (convenience)
exports.metersPerFoot = 0.3048;
exports.metersPerInch = 0.0254;
exports.metersPerYard = 0.9144;
/**
 * Sports
 */
exports.Sports = [
    "PLATFORM_TENNIS",
    "PADEL",
    "TENNIS",
    "PICKLEBALL",
    "LACROSSE",
];
function isSport(sport) {
    return exports.Sports.includes(sport);
}
/**
 * Physics Models
 */
exports.ValidPhysicsModelNames = [
    "physics-20B-base",
    "physics-20C-base",
    "physics-20D-base",
    "physics-20E-base",
    "physics-20F-base",
    "physics-20G-base",
    "physics-20H-base",
    "physics-20I-base",
    "physics-20X-base",
    "physics-30A-base",
    "physics-30B-base",
    "physics-30C-base",
    "physics-30D-base",
    "physics-30E-base",
    "physics-30X-base",
];
/**
 * CourtSurface
 * The surfaces the ball can hit.
 */
var CourtSurface;
(function (CourtSurface) {
    CourtSurface["Court"] = "Court";
    CourtSurface["LeftWall"] = "LeftWall";
    CourtSurface["RightWall"] = "RightWall";
    CourtSurface["BackWall"] = "BackWall";
    CourtSurface["Net"] = "Net";
})(CourtSurface || (exports.CourtSurface = CourtSurface = {}));
exports.BallParamsBySport = {
    PLATFORM_TENNIS: {
        diameter: 2.5 * 0.0254,
        mass: 0.072,
        drag: 0.85,
    },
    PADEL: {
        diameter: 6.7 * 0.01,
        mass: 57.7 * 0.001,
        drag: 0.637,
    },
    TENNIS: {
        diameter: 6.7 * 0.01,
        mass: 57.7 * 0.001,
        drag: 0.637,
    },
    PICKLEBALL: {
        diameter: 7.425 * 0.01,
        mass: 24.3 * 0.001,
        drag: 0.525,
    },
    // Lacrosse is thrown with a platform tennis ball: the trainer has not been
    // redesigned to feed a lacrosse ball. These values are deliberately identical
    // to PLATFORM_TENNIS above and should not be "corrected" to lacrosse-ball
    // figures unless the hardware actually changes.
    LACROSSE: {
        diameter: 2.5 * 0.0254,
        mass: 0.072,
        drag: 0.85,
    },
};
/**
 * CourtGeometryBySport
 * Select sport-specific court geometry
 */
exports.CourtGeometryBySport = {
    PLATFORM_TENNIS: {
        PLATFORM_WIDTH: 30.0 * exports.metersPerFoot,
        PLATFORM_LENGTH: 60.0 * exports.metersPerFoot,
        COURT_WIDTH: 20.0 * exports.metersPerFoot,
        COURT_LENGTH: 44.0 * exports.metersPerFoot,
        SERVICE_WIDTH: 16.0 * exports.metersPerFoot,
        SERVICE_LENGTH: 24.0 * exports.metersPerFoot,
        NET_WIDTH: 26.0 * exports.metersPerFoot,
        NET_HEIGHT_POST: 3.083 * exports.metersPerFoot,
        NET_HEIGHT_CENTER: 2.833 * exports.metersPerFoot,
        WALL_HEIGHT: 12 * exports.metersPerFoot,
        TALL_WALL_HEIGHT: 0,
        TALL_WALL_SIDE_LENGTH: 0,
    },
    PADEL: {
        PLATFORM_WIDTH: 10.0,
        PLATFORM_LENGTH: 20.0,
        COURT_WIDTH: 10.0,
        COURT_LENGTH: 20.0,
        SERVICE_WIDTH: 10.0,
        SERVICE_LENGTH: 14.0,
        NET_WIDTH: 10.0,
        NET_HEIGHT_POST: 0.92,
        NET_HEIGHT_CENTER: 0.88,
        WALL_HEIGHT: 3.0,
        TALL_WALL_HEIGHT: 4.0,
        TALL_WALL_SIDE_LENGTH: 2.0,
    },
    TENNIS: {
        PLATFORM_WIDTH: 60.0 * exports.metersPerFoot,
        PLATFORM_LENGTH: 120.0 * exports.metersPerFoot,
        COURT_WIDTH: 36.0 * exports.metersPerFoot,
        COURT_LENGTH: 78.0 * exports.metersPerFoot,
        SERVICE_WIDTH: 27.0 * exports.metersPerFoot,
        SERVICE_LENGTH: 42.0 * exports.metersPerFoot,
        NET_WIDTH: 42.0 * exports.metersPerFoot,
        NET_HEIGHT_POST: 3.51 * exports.metersPerFoot,
        NET_HEIGHT_CENTER: 3.0 * exports.metersPerFoot,
        WALL_HEIGHT: 0,
        TALL_WALL_HEIGHT: 0,
        TALL_WALL_SIDE_LENGTH: 0,
    },
    PICKLEBALL: {
        PLATFORM_WIDTH: 30.0 * exports.metersPerFoot,
        PLATFORM_LENGTH: 60.0 * exports.metersPerFoot,
        COURT_WIDTH: 20.0 * exports.metersPerFoot,
        COURT_LENGTH: 44.0 * exports.metersPerFoot,
        SERVICE_WIDTH: 20.0 * exports.metersPerFoot,
        // SERVICE_LENGTH = KITCHEN FOR PICKLEBALL
        SERVICE_LENGTH: 14.0 * exports.metersPerFoot,
        NET_WIDTH: 22.0 * exports.metersPerFoot,
        NET_HEIGHT_POST: 3.0 * exports.metersPerFoot,
        NET_HEIGHT_CENTER: (34.0 / 12.0) * exports.metersPerFoot,
        WALL_HEIGHT: 0,
        TALL_WALL_HEIGHT: 0,
        TALL_WALL_SIDE_LENGTH: 0,
    },
    // Lacrosse is played on an open field: no net, no walls, no service boxes.
    // A zero NET_HEIGHT_CENTER / WALL_HEIGHT disables the net and wall bounce
    // tests outright - both are strict "ball z < height" comparisons.
    //
    // The playing volume has to be field-sized rather than court-sized:
    // PLATFORM_WIDTH/LENGTH are what TrainerSim._ballOutOfBounds() clips
    // against, and with the walls gone nothing else keeps a high-speed shot
    // inside the simulation.
    //
    // These are the MAXIMUM PERMITTED field dimensions, not any one field's
    // actual size, and that is the point: they are simulation bounds.
    //
    // A men's field of play is 110 x 60 yd. The women's rules permit
    // 110-120 x 60-70 yd and call 120 x 65 optimal. So 120 x 70 is not
    // "the women's field" - it is the largest field either code allows, which
    // is the only choice that is strictly permissive. No shot that would be
    // tracked on a real field of any variant is lost here. The cost is that on
    // a men's field the sim keeps tracking for up to ~4.6m past the real
    // sideline, which is invisible because nothing acts on the boundary.
    //
    // The drawn field is a different table in a different frame. Field
    // MARKINGS live in webby-app's util/lacrosse/geometry.ts, keyed by variant
    // and measured from the goal line rather than the field centre - that is
    // the simulation-bounds / court-markings split, performed at the module
    // level rather than as a change to the CourtGeometry type. Nothing else
    // needs these two to agree, because buildLayout never sees Lacrosse.
    //
    // workout-kinematics is still blocked, and not by this entry: naming where
    // a shot landed needs the VARIANT to pick the marking rectangle, and the
    // variant is presentation-only and deliberately never reaches the server.
    // That is a schema decision, not a geometry one.
    LACROSSE: {
        PLATFORM_WIDTH: 70.0 * exports.metersPerYard,
        PLATFORM_LENGTH: 120.0 * exports.metersPerYard,
        COURT_WIDTH: 70.0 * exports.metersPerYard,
        COURT_LENGTH: 120.0 * exports.metersPerYard,
        SERVICE_WIDTH: 0,
        SERVICE_LENGTH: 0,
        NET_WIDTH: 0,
        NET_HEIGHT_POST: 0,
        NET_HEIGHT_CENTER: 0,
        WALL_HEIGHT: 0,
        TALL_WALL_HEIGHT: 0,
        TALL_WALL_SIDE_LENGTH: 0,
    },
};
/**
 * DefaultPhysicalConstants
 * Default values for the physical constants required for simulation.
 */
exports.DefaultPhysicalConstants = {
    gravity: 9.8,
    airDensity: 1.225,
    wallRestCoeff: 0.5,
    courtRestCoeff: 0.8,
    netRestCoeff: 0.01,
};
/**
 * DefaultSimulationParams
 * Default values for parameters that control ball flight simulation.
 */
exports.DefaultSimulationParams = {
    timeStep: 0.001, // about 2 inches @ 60 mph
    duration: 5.0, // simulate for 5 seconds
    bounces: 3, // or 3 bounces, whichever comes first
    wallBounceEnabled: true, // walls are not invisible
    netBounceEnabled: true, // net is not invisible
    maxSteps: 50, // iter solving: iteration stops after this many steps
    stepDecay: 0.6, // iter solving: reduce step size by this fraction every iter
    stopDist: 0.001,
};
